import { AppRoute } from '@agentselly/immodossier-shared';
import { createFileRoute } from '@tanstack/react-router';
import { OAuthFailurePage } from '~/components/OAuthCallback';

export const Route = createFileRoute('/auth/failure' as any)({
  component: function Body() {
    return <OAuthFailurePage />;
  },
});
